<div class="bg-white p-6">

  <h2>Users</h2>
  <app-user-list class="user-list" [users]="(users$ | async)!" (add)="onAdd($event)"></app-user-list>

  <h2>My Collection</h2>
  <app-user-collection class="user-collection" [users]="(userCollection$ | async)!" (remove)="onRemove($event)">
  </app-user-collection>

</div>
